"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.translationMap = void 0;
var tslib_1 = require("tslib");
/* eslint-disable */
var zh_cn_1 = require("./locale/zh_cn");
var en_us_1 = require("./locale/en_us");
var ja_1 = require("./locale/ja");
var ko_1 = require("./locale/ko");
var ar_1 = require("./locale/ar");
exports.translationMap = {
    zh_cn: zh_cn_1.zh_cn,
    zh: zh_cn_1.zh_cn,
    en_us: (0, tslib_1.__assign)((0, tslib_1.__assign)({}, zh_cn_1.zh_cn), en_us_1.en_us),
    en: (0, tslib_1.__assign)((0, tslib_1.__assign)({}, zh_cn_1.zh_cn), en_us_1.en_us),
    ja: (0, tslib_1.__assign)((0, tslib_1.__assign)((0, tslib_1.__assign)({}, zh_cn_1.zh_cn), en_us_1.en_us), ja_1.ja),
    jp: (0, tslib_1.__assign)((0, tslib_1.__assign)((0, tslib_1.__assign)({}, zh_cn_1.zh_cn), en_us_1.en_us), ja_1.ja),
    ko: (0, tslib_1.__assign)((0, tslib_1.__assign)((0, tslib_1.__assign)({}, zh_cn_1.zh_cn), en_us_1.en_us), ko_1.ko),
    ar: (0, tslib_1.__assign)((0, tslib_1.__assign)((0, tslib_1.__assign)({}, zh_cn_1.zh_cn), en_us_1.en_us), ar_1.ar),
};
/* eslint-enable */
